exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".code-box{flex:1;height:0;display:flex;flex-flow:column}.code-box,.code-editor{overflow:auto;padding:5px}.code-editor{flex:1;background:rgba(0,0,0,.15);font-size:12px;resize:none;color:#75b325;outline:0;border:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3bc411d8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shell/components/options/CodeBox.vue
// module id = 108
// module chunks = 0 1